import { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import { useMemoCompare } from "../../hooks";
import {
  Breadcrumb,
  CrumbInstance,
  useBreadcrumbUtils,
} from "./BreadcrumbsProvider";

export const useCrumb = (data: Breadcrumb) => {
  const { register } = useBreadcrumbUtils();

  // holds the memoized copy of crumb data
  const crumb = useMemoCompare(data, isEqual)!;

  const instance = useRef<CrumbInstance>();

  useEffect(() => {
    if (!instance.current) {
      // registration
      register(crumb)(instance);
    } else {
      // updates
      instance.current?.update(crumb);
    }
  }, [crumb, register]);

  // remove
  useEffect(
    () => () => {
      instance.current?.remove();
    },
    [],
  );

  return instance;
};
